import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Body from './Body'
ReactDOM.render(
  <React.StrictMode>
    <Body />
  </React.StrictMode>,
  document.getElementById('root')
);

